module.exports = __webpack_public_path__ + "img/chart3.f3279639.png";